function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#3C59BA",
  d: "M22.6753125 0H1.3246875C.5930828 0 0 .5930828 0 1.3246875v21.350625C0 23.4069172.5930828 24 1.3246875 24h11.495625v-9.28125H9.703125v-3.6328125h3.1171875v-2.671875c0-3.09984375 1.8932812-4.7878125 4.6584375-4.7878125 1.3242187 0 2.4628125.0984375 2.7946875.140625v3.23953125h-1.906875c-1.5046875 0-1.79625.71484375-1.79625 1.764375v2.31515625H20.1675l-.46875 3.6328125h-3.1284375V24h6.105C23.4069172 24 24 23.4069172 24 22.6753125V1.3246875C24 .5930828 23.4069172 0 22.6753125 0z"
}), React.createElement("path", {
  fill: "#FBFCFC",
  d: "M16.5703125 24v-9.28125h3.1289062l.46875-3.6328125h-3.5976562v-2.31375c0-1.04953125.2915625-1.764375 1.79625-1.764375h1.906875V3.76734375c-.331875-.0440625-1.4704688-.140625-2.7946875-.140625-2.765625 0-4.6584375 1.6875-4.6584375 4.7878125v2.67187495H9.703125V14.71875h3.1171875V24h3.75z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/facebook-icon.c161575a.svg";
export { SvgComponent as ReactComponent };